import React from 'react'
import Select from 'react-select'
import { Form as frm, InputGroup } from 'react-bootstrap'
import {
  currencyIcon,
  isAllowPriceVariant,
  isAllowWarehouseManagement,
  prepareDisplayCalculationData
} from '../../lib/GetBaseUrl'
import FormikControl from '../../components/FormikControl'
import { customStyles } from '../../components/customStyles'

const PricingDetails = ({
  values,
  allState,
  setFieldValue,
  fetchCalculation,
  setCalculation,
  calculation
}) => {
  return (
    <div className='col-md-6'>
      <div className='card'>
        <div className='card-body'>
          <div className='row main_div'>
            <h5 className='mb-3 head_h3'>Pricing Details</h5>

            {values?.isSizeWisePriceVariant &&
              allState?.sizeType?.length > 0 &&
              isAllowPriceVariant && (
                <>
                  <div className='col-md-4 mb-3'>
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label required'>Size Value</label>
                      <Select
                        id='tempSizeValueId'
                        placeholder='Size Type'
                        value={
                          values?.tempSizeValueId && {
                            value: values?.tempSizeValueId,
                            label: values?.tempSizeValueName
                          }
                        }
                        options={values?.productPrices
                          ?.filter((data) => !data?.isDataInTable)
                          ?.map(({ sizeID, sizeName }) => ({
                            label: sizeName,
                            value: sizeID
                          }))}
                        onBlur={() => {
                          if (
                            values?.productPrice?.filter(
                              (data) => !data?.isDataInTable
                            )?.length
                          ) {
                            if (values?.tempSizeValueId) {
                              setFieldValue('validation', {
                                ...values?.validation,
                                tempSizeValueId: ''
                              })
                            } else {
                              setFieldValue('validation', {
                                ...values?.validation,
                                tempSizeValueId: 'Size Value Required'
                              })
                            }
                          }
                        }}
                        onChange={(e) => {
                          if (
                            values?.productPrice?.filter(
                              (data) => !data?.isDataInTable
                            )?.length
                          ) {
                            if (e?.value) {
                              setFieldValue('validation', {
                                ...values?.validation,
                                tempSizeValueId: ''
                              })
                            } else {
                              setFieldValue('validation', {
                                ...values?.validation,
                                tempSizeValueId: 'Size Value Required'
                              })
                            }
                          }
                          setFieldValue('tempSizeValueId', e?.value)
                          setFieldValue('tempSizeValueName', e?.label)
                          setFieldValue('quantity', '')
                          setFieldValue('mrp', '')
                          setFieldValue('sellingPrice', '')
                          setFieldValue('discount', '')
                          let productPriceList = values?.productPrices ?? []

                          if (productPriceList.length > 0) {
                            productPriceList = productPriceList?.map((data) => {
                              if (data?.sizeID === e?.value) {
                                return {
                                  ...data,
                                  mrp: '',
                                  sellingPrice: '',
                                  discount: '',
                                  quantity: '',
                                  manageWarehouseStock: false,
                                  perWarehouseStock: '',
                                  sizeID: data?.sizeID,
                                  sizeName: data?.sizeName,
                                  isCheckedForQty: true
                                }
                              } else {
                                return {
                                  ...data,
                                  isCheckedForQty: false
                                }
                              }
                            })
                          }

                          setFieldValue('productPrices', productPriceList)
                        }}
                      />
                      {values?.validation?.tempSizeValueId && (
                        <span className='text-danger'>
                          {values?.validation?.tempSizeValueId}
                        </span>
                      )}
                    </div>
                  </div>
                  {!isAllowWarehouseManagement ? (
                    <div className='col-md-4 mb-3'>
                      <div className='input-file-wrapper mb-3'>
                        <FormikControl
                          disabled={!isAllowWarehouseManagement ? false : true}
                          control='input'
                          label='Total Quantity'
                          value={values?.quantity}
                          id='qty'
                          type='number'
                          name='quantity'
                          placeholder='Quantity'
                          onChange={(e) => {
                            if (Number(e?.target?.value) >= 0) {
                              setFieldValue('quantity', e?.target?.value)
                              let productPriceList = values?.productPrices ?? []

                              if (productPriceList.length > 0) {
                                productPriceList = productPriceList?.map(
                                  (data) => {
                                    if (
                                      data?.sizeID === values?.tempSizeValueId
                                    ) {
                                      return {
                                        mrp: '',
                                        sellingPrice: '',
                                        discount: '',
                                        productWarehouses: [],
                                        quantity: e?.target?.value,
                                        sizeID: data?.sizeID,
                                        sizeName: data?.sizeName,
                                        isCheckedForQty: true
                                      }
                                    } else {
                                      return {
                                        ...data,
                                        isCheckedForQty: false
                                      }
                                    }
                                  }
                                )
                              }
                              setFieldValue('productPrices', productPriceList)
                            }
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className='col-md-4 mb-3'></div>
                  )}

                  <div className='col-md-4 mb-3'></div>
                </>
              )}
            <div className='col-md-4  mb-3'>
              <label className='form-label required' htmlFor='mrp'>
                MRP
              </label>
              <InputGroup>
                <frm.Control
                  id='mrp'
                  placeholder='MRP'
                  value={values?.mrp}
                  onChange={(e) => {
                    let productPrices = []
                    const inputValue = e.target.value
                    const regex = /^[0-9\b]+$/
                    if (inputValue === '' || regex.test(inputValue)) {
                      setFieldValue('mrp', e?.target?.value)
                      if (!allState?.sizeType?.length) {
                        productPrices.push({
                          mrp: e?.target?.value,
                          sellingPrice: values?.sellingPrice ?? '',
                          discount: values?.discount ?? '',
                          quantity: 1,
                          sizeID: null,
                          productWarehouses: []
                        })
                        setFieldValue('productPrices', productPrices)
                      }
                      if (e?.target?.value) {
                        if (e?.target?.value == 0) {
                          setFieldValue('validation', {
                            ...values?.validation,
                            mrp: 'MRP cant be 0'
                          })
                        } else {
                          setFieldValue('validation', {
                            ...values?.validation,
                            mrp: ''
                          })
                        }
                      } else {
                        setFieldValue('validation', {
                          ...values?.validation,
                          mrp: 'MRP Required'
                        })
                      }
                    }
                  }}
                  onBlur={(e) => {
                    let mrp = Number(values?.mrp)
                    let sellingPrice = Number(values?.sellingPrice)
                    let discount = values?.discount

                    if (!values?.mrp) {
                      setFieldValue('validation', {
                        ...values?.validation,
                        mrp: 'MRP Required'
                      })
                      mrp = ''
                      discount = ''
                      sellingPrice = values?.sellingPrice
                        ? values?.sellingPrice
                        : ''
                    } else if (mrp === 0) {
                      setFieldValue('validation', {
                        ...values?.validation,
                        mrp: 'MRP cant be 0'
                      })
                      discount = ''
                    } else if (mrp && sellingPrice) {
                      if (mrp < sellingPrice) {
                        mrp = ''
                        discount = ''
                        setFieldValue('validation', {
                          ...values?.validation,
                          mrp: 'MRP should not be less than Selling Price '
                        })
                      } else if (sellingPrice && sellingPrice > 0) {
                        discount = ((mrp - sellingPrice) / mrp) * 100
                        discount = discount.toFixed(2)
                        setFieldValue('validation', {
                          ...values?.validation,
                          discount: ''
                        })
                      }
                    } else {
                      discount = ''
                      sellingPrice = ''
                    }

                    setFieldValue('mrp', mrp)
                    setFieldValue('sellingPrice', sellingPrice)
                    setFieldValue('discount', discount)

                    let productPricesArray = values?.productPrices ?? []
                    productPricesArray = productPricesArray?.map((product) => {
                      if (values?.isSizeWisePriceVariant) {
                        if (product?.sizeID === values?.tempSizeValueId) {
                          return {
                            ...product,
                            mrp,
                            discount,
                            sellingPrice
                          }
                        } else {
                          return product
                        }
                      } else {
                        return {
                          ...product,
                          mrp,
                          sellingPrice,
                          discount
                        }
                      }
                    })

                    setFieldValue('productPrices', productPricesArray)
                    if (values?.mrp !== '')
                      fetchCalculation(
                        'Product/DisplayCalculation',
                        prepareDisplayCalculationData(values),
                        (data) => {
                          setCalculation({
                            ...calculation,
                            displayCalculation: data
                          })
                        }
                      )
                  }}
                />
                <InputGroup.Text>{currencyIcon}</InputGroup.Text>
              </InputGroup>
              {values?.validation?.mrp && (
                <span className='text-danger'>{values?.validation?.mrp}</span>
              )}
            </div>
            <div className='col-md-4  mb-3'>
              <label className='form-label required' htmlFor='sell'>
                Selling Price
              </label>
              <InputGroup>
                <frm.Control
                  id='sellingPrice'
                  placeholder='Selling price'
                  value={values?.sellingPrice}
                  onBlur={() => {
                    let mrp = Number(values?.mrp)
                    let sellingPrice = Number(values?.sellingPrice)
                    let discount = values?.discount

                    if (!values?.sellingPrice) {
                      setFieldValue('validation', {
                        ...values?.validation,
                        sellingPrice: 'Selling Price Required'
                      })
                      sellingPrice = ''
                      mrp = values?.mrp ? values?.mrp : ''
                      discount = ''
                    } else if (sellingPrice === 0) {
                      setFieldValue('validation', {
                        ...values?.validation,
                        sellingPrice: 'Selling Price cant be 0'
                      })
                      discount = ''
                    } else if (mrp && sellingPrice) {
                      if (sellingPrice > mrp) {
                        discount = ''
                        sellingPrice = ''
                        setFieldValue('validation', {
                          ...values?.validation,
                          sellingPrice:
                            'Selling Price should not be greater than MRP '
                        })
                      } else if (mrp && mrp > 0) {
                        discount = ((mrp - sellingPrice) / mrp) * 100
                        discount = discount.toFixed(2)
                        setFieldValue('validation', {
                          ...values?.validation,
                          discount: ''
                        })
                      }
                    } else {
                      discount = ''
                    }

                    setFieldValue('mrp', mrp)
                    setFieldValue('sellingPrice', sellingPrice)
                    setFieldValue('discount', discount)
                    fetchCalculation(
                      'Product/DisplayCalculation',
                      prepareDisplayCalculationData(values),
                      (data) => {
                        setCalculation({
                          ...calculation,
                          displayCalculation: data
                        })
                      }
                    )

                    let productPricesArray = values?.productPrices ?? []
                    if (productPricesArray?.length > 0) {
                      productPricesArray = productPricesArray?.map(
                        (product) => {
                          if (values?.isSizeWisePriceVariant) {
                            if (product.sizeID === values?.tempSizeValueId)
                              return {
                                ...product,
                                sellingPrice,
                                discount,
                                mrp
                              }
                            else {
                              return product
                            }
                          } else {
                            return {
                              ...product,
                              sellingPrice,
                              discount,
                              mrp
                            }
                          }
                        }
                      )
                    }
                    setFieldValue('productPrices', productPricesArray)
                  }}
                  onChange={(e) => {
                    let productPrices = []
                    const inputValue = e.target.value
                    const regex = /^[0-9\b]+$/
                    if (inputValue === '' || regex.test(inputValue)) {
                      setFieldValue('sellingPrice', e?.target?.value)
                      if (!allState?.sizeType?.length) {
                        productPrices.push({
                          mrp: values?.mrp ?? '',
                          sellingPrice: inputValue ?? '',
                          discount: values?.discount ?? '',
                          quantity: 1,
                          sizeID: null,
                          productWarehouses: []
                        })
                        setFieldValue('productPrices', productPrices)
                      }
                      if (e?.target?.value) {
                        if (e?.target?.value == 0) {
                          setFieldValue('validation', {
                            ...values?.validation,
                            sellingPrice: 'Selling Price cant be 0'
                          })
                        } else if (
                          Number(e?.target?.value) > Number(values?.mrp)
                        ) {
                          setFieldValue('validation', {
                            ...values?.validation,
                            sellingPrice:
                              'Selling Price should be less than MRP'
                          })
                        } else {
                          setFieldValue('validation', {
                            ...values?.validation,
                            sellingPrice: ''
                          })
                        }
                      } else {
                        setFieldValue('validation', {
                          ...values?.validation,
                          sellingPrice: 'Selling Price Required'
                        })
                      }
                    }
                  }}
                />
                <InputGroup.Text>{currencyIcon}</InputGroup.Text>
              </InputGroup>
              {values?.validation?.sellingPrice && (
                <span className='text-danger'>
                  {values?.validation?.sellingPrice}
                </span>
              )}
            </div>

            <div className='col-md-4 mb-3'>
              <label className='form-label required' htmlFor='discount'>
                Discount
              </label>
              <InputGroup>
                <frm.Control
                  name='discount'
                  id='discount'
                  value={values?.discount}
                  placeholder='Discount'
                  onBlur={(e) => {
                    let mrp = Number(values?.mrp)
                    let sellingPrice = Number(values?.sellingPrice)
                    let discount = values?.discount
                    if (values?.mrp && values?.discount) {
                      let discountPercentage = discount / 100
                      sellingPrice = mrp - mrp * discountPercentage
                      sellingPrice = Math.round(sellingPrice)
                      discount = ((mrp - sellingPrice) / mrp) * 100
                      discount = discount.toFixed(2)
                      if (sellingPrice < 1) {
                        setFieldValue('validation', {
                          ...values?.validation,
                          sellingPrice: 'Selling Price cant be less than 0'
                        })
                      } else {
                        setFieldValue('validation', {
                          ...values?.validation,
                          sellingPrice: ''
                        })
                      }
                    } else if (values?.mrp && values?.sellingPrice) {
                      discount = ((mrp - sellingPrice) / mrp) * 100
                      discount = discount.toFixed(2)
                      setFieldValue('validation', {
                        ...values?.validation,
                        discount: ''
                      })
                    } else if (
                      !values?.mrp &&
                      !values?.sellingPrice &&
                      values?.discount
                    ) {
                      mrp = ''
                      sellingPrice = ''
                      setFieldValue('validation', {
                        ...values?.validation,
                        mrp: 'MRP Required',
                        sellingPrice: 'Selling Price Required'
                      })
                    } else if (
                      !values?.mrp &&
                      !values?.sellingPrice &&
                      !values?.discount
                    ) {
                      setFieldValue('validation', {
                        ...values?.validation,
                        mrp: 'MRP Required',
                        sellingPrice: 'Selling Price Required',
                        discount: 'Discount Required'
                      })
                      mrp = ''
                      sellingPrice = ''
                      discount = ''
                    }

                    setFieldValue('mrp', mrp)
                    setFieldValue('sellingPrice', sellingPrice)
                    setFieldValue('discount', discount)
                    fetchCalculation(
                      'Product/DisplayCalculation',
                      prepareDisplayCalculationData(values),
                      (data) => {
                        setCalculation({
                          ...calculation,
                          displayCalculation: data
                        })
                      }
                    )

                    let productPricesArray = values?.productPrices ?? []
                    if (productPricesArray?.length > 0) {
                      productPricesArray = productPricesArray?.map(
                        (product) => {
                          if (values?.isSizeWisePriceVariant) {
                            if (product.sizeID === values.tempSizeValueId)
                              return {
                                ...product,
                                discount,
                                sellingPrice,
                                mrp
                              }
                            else {
                              return product
                            }
                          } else {
                            return {
                              ...product,
                              sellingPrice,
                              discount,
                              mrp
                            }
                          }
                        }
                      )
                    }
                    setFieldValue('productPrices', productPricesArray)
                  }}
                  onChange={(e) => {
                    let productPrices = []
                    const inputValue = e.target.value
                    const regex = /^\d*\.?\d+$/
                    if (inputValue === '' || regex.test(inputValue)) {
                      if (e?.target?.value <= 100) {
                        setFieldValue('validation', {
                          ...values?.validation,
                          discount: ''
                        })
                        setFieldValue('discount', e?.target?.value)
                        if (!allState?.sizeType?.length) {
                          productPrices.push({
                            mrp: values?.mrp ?? '',
                            sellingPrice: values?.sellingPrice ?? '',
                            discount: inputValue ?? '',
                            quantity: 1,
                            sizeID: null,
                            productWarehouses: []
                          })
                          setFieldValue('productPrices', productPrices)
                        }
                      } else if (e?.target?.value > 100) {
                        setFieldValue('validation', {
                          ...values?.validation,
                          discount: 'Discount cant be greater than 100'
                        })
                      } else {
                        setFieldValue('validation', {
                          ...values?.validation,
                          discount: 'Discount Required'
                        })
                      }
                    }
                  }}
                />
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup>
              {values?.validation?.discount && (
                <span className='text-danger'>
                  {values?.validation?.discount}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingDetails
